var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-list-item-title"},[_c('div',{staticClass:"notification-list-item-title-text"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }